import { Component, inject } from '@angular/core';

import { ToastService } from './toast-service';
import { NgTemplateOutlet } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-toasts',
	standalone: true,
	imports: [NgbToastModule, NgTemplateOutlet],
	styleUrl: "./toast.scss",
	template: `
		@for (toast of toastService.toasts; track toast) {
			<ngb-toast
				[header]="toast.header?toast.header:''"
				[class]="toast.classname"
				[autohide]="true"
				[delay]="toast.delay || 5000"
				(hidden)="toastService.remove(toast)"
			>
				<ng-template [ngTemplateOutlet]="toast.template"></ng-template>
				{{toast.body}}
			</ngb-toast>
		}
	`,
	host: {
		class: 'toast-container position-fixed bottom-0 end-0 p-3',
		style: 'z-index: 1200',
	},
})
export class ToastsContainer {
	toastService = inject(ToastService);
}
